var React = require('react');

function NavigationMenuHorizontal (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("circle",{"className":"a","cx":"3.375","cy":"12.023","r":"2.625","key":1}),React.createElement("circle",{"className":"a","cx":"20.625","cy":"12.023","r":"2.625","key":2}),React.createElement("circle",{"className":"a","cx":"12","cy":"12.023","r":"2.625","key":3})]);
}

NavigationMenuHorizontal.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavigationMenuHorizontal;

NavigationMenuHorizontal.default = NavigationMenuHorizontal;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/navigation-menu-horizontal.svg
// module id = 1076
// module chunks = 0